// import Swiper JS
import Swiper from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.css';
// import Swiper and modules styles
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css/bundle';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const $ = window.jQuery;
const startSwiper = {

    init() {
        var $BAHeroSlider = $(document).find('#BA-hero-swiper');

        if (!$BAHeroSlider.length)
            return;
            const swiper = new Swiper("#BA-hero-swiper", {
              	// configure Swiper to use modules
		            modules: [Navigation, Pagination, Autoplay],
                pagination: {
                  el: ".swiper-pagination",
                  clickable: true,
                },
                autoplay: {
                  delay: 3500,
                  disableOnInteraction: false,
                },
              });
       
    },

};

export default startSwiper;
